export type Grade = 'S' | 'A' | 'B' | 'C' | 'D';

export interface ScoreResult {
  clearTime: number;
  remainingHpPct: number;
  totalScore: number;
  grade: Grade;
  isGameOver: boolean;
}

export function calculateScore(
  clearTime: number,
  remainingHp: number,
  maxHp: number,
  missilesFired: number,
  vulcanHits: number,
): ScoreResult {
  const hpPct = Math.round((remainingHp / maxHp) * 100);

  // 時間スコア: 10000基点、秒ごとに-50
  const timeScore = Math.max(0, 10000 - Math.floor(clearTime) * 50);

  // HPスコア: 残HP%×50（最大5000）
  const hpScore = Math.floor(hpPct * 50);

  // 効率スコア: ミサイル節約ボーナス
  const efficiencyScore = Math.max(0, 3000 - missilesFired * 200);

  // バルカン命中ボーナス
  const hitScore = vulcanHits * 20;

  const totalScore = timeScore + hpScore + efficiencyScore + hitScore;

  let grade: Grade;
  if (totalScore >= 15000) grade = 'S';
  else if (totalScore >= 12000) grade = 'A';
  else if (totalScore >= 8000) grade = 'B';
  else if (totalScore >= 4000) grade = 'C';
  else grade = 'D';

  return { clearTime, remainingHpPct: hpPct, totalScore, grade, isGameOver: false };
}
